import { createFileRoute } from '@tanstack/react-router';
import { DummyPage } from '~/modules/dummy/dummy.components/dummy-page';

export const Route = createFileRoute('/_main-layout/')({
  component: DummyPage,
});
